<template>
  <div>
    <div class="flex justify-between items-center">
      <h2>Pricing Rules</h2>
      <button class="btn btn-blue m-1" @click="$refs.addPricingModal.show()">Add Rule</button>
    </div>
    <div v-if="pricing_rules.length" class="py-8">
      <showman-table :tableData="pricing_rules" :tableFields="pricing_fields">
        <div slot="type" slot-scope="data">
          {{data.item.type}}
          <div class="text-gray-800 text-sm">
            <div>
              Special pricing
            </div>
          </div>
        </div>
        <div slot="rule" slot-scope="data">
          <span class="text-lg md:text-xl">{{data.item.details.name}}</span>
          <div class='flex flex-col md:flex-row justify-start text-gray-800'>
            <div v-for="s in data.item.details.show_ids" :key="s.value" class="pr-2">{{showDecode[s.value].name}}</div>
          </div>
          <div class="flex flex-col md:flex-row">
            <div v-if="event.entry_settings.early_bird_date" class="pr-1">Early-{{currencySymbol}}{{data.item.details.early_rate}} |</div>
            <div class="pr-1">Normal-{{currencySymbol}}{{data.item.details.rate}} |</div>
            <div>Late-{{currencySymbol}}{{data.item.details.late_rate}}</div>
          </div>
        </div>
        <div slot=" " slot-scope="data">
          <div class="text-center">
            <button class="btn-blue-outline btn-xs m-1" @click="editPricingRule(data.item)">Edit</button>
            <button class="btn-red-outline btn-xs m-1" @click="removePricingRule(data.item)">X</button>
          </div>
        </div>
      </showman-table>

    </div>
    <div v-else class="text-center py-8 text-2xl">
      No pricing rules defined
    </div>
    <b-modal id="addPricingModal" ref="addPricingModal" size="lg" :title="`Add Pricing Rule`" no-close-on-backdrop>
      <form class="mt-4">
        <div class='mb-4'>
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Rule Type
          </label>
          <div class="relative">
            <select v-model="new_pricing.type" class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
              <option :value="null" selected disabled>
                Please select a type
              </option>
              <option v-for="v in pricing_types" :key="v.value" :value="v.value">
                {{v.label}}
              </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>
        <div class="hr"></div>
        <div v-if="new_pricing.type == 'MULTI'">

          <div class='mb-4'>
            <label class="block text-gray-700 text-sm font-bold mb-2">
              What is the name of this rule?
            </label>
            <input type="text" v-model="new_pricing.details.name" placeholder="Rule Name" class="text-input focus:outline-none focus:shadow-outline">
          </div>
          <h5>Which shows make up this multi entry rule?</h5>
          <multiselect v-model="new_pricing.details.show_ids" :options="showList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select multiple shows" label="name" track-by="name" :preselect-first="false" :custom-label="(option) => {return option.name ? option.name : showDecode[option].name}" :hideSelected="true"></multiselect>
          <p class="text-xs text-gray-600">Please select at least 2 shows to contiue setting up the pricing rule.</p>
          <!--<div class="relative flex items-start mt-3" v-if="new_pricing.details.show_ids.length > 2">
            <div class="flex h-5 items-center">
              <input v-model="new_pricing.details.partial_entry_modifers" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
            </div>
            <div class="ml-3 text-sm">
              <label for="comments" class="font-medium text-gray-700">Add Partial Entry Modifers</label>
              <p id="comments-description" class="text-gray-500">Check this box if you allow a disocunt for different combination of entry. i.e. Entering 2 of the possible 3 shows. By default all shows will need to be entered to recieve this discount.</p>
            </div>
          </div>-->
          <!--<template v-if="new_pricing.details.show_ids.length > 1">
            <div v-for="i in new_pricing.details.partial_entry_modifers ? new_pricing.details.show_ids.length - 1 : 1" :key="i" class="mt-4">
              <p class="text-2xl text-center mb-1">{{new_pricing.details.partial_entry_modifers ? i + 1 : new_pricing.details.show_ids.length}} Show Pricing</p>
              <div class="bg-gray-200 p-2 rounded">
                <div v-if="event.entry_settings.has_member_pricing">
                  <p class="text-lg border-b pb-1 mb-1">Member Pricing</p>
                  <div class="flex flex-col sm:flex-row sm:justify-start sm:space-x-3 space-y-2 sm:space-y-0">
                    <div v-if="event.entry_settings.early_bird_date">
                      <label class="block text-sm font-medium text-gray-700">Early Rate</label>
                      <div class="mt-1">
                        <input type="number" v-model.number="new_pricing.details.member_early_rate" class="new-form-input">
                      </div>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700">Normal Rate</label>
                      <div class="mt-1">
                        <input type="number" v-model.number="new_pricing.details.member_normal_rate" class="new-form-input">
                      </div>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700">Late Rate</label>
                      <div class="mt-1">
                        <input type="number" v-model.number="new_pricing.details.member_late_rate" class="new-form-input">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-4">
                  <p class="text-lg border-b pb-1 mb-1"><span v-if="event.entry_settings.has_member_pricing">Non-Member </span>Pricing</p>
                  <div class="flex flex-col sm:flex-row sm:justify-start sm:space-x-3 space-y-2 sm:space-y-0">
                    <div v-if="event.entry_settings.early_bird_date">
                      <label class="block text-sm font-medium text-gray-700">Early Rate</label>
                      <div class="mt-1">
                        <input type="number" v-model.number="new_pricing.details.early_rate" class="new-form-input">
                      </div>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700">Normal Rate</label>
                      <div class="mt-1">
                        <input type="number" v-model.number="new_pricing.details.normal_rate" class="new-form-input">
                      </div>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700">Late Rate</label>
                      <div class="mt-1">
                        <input type="number" v-model.number="new_pricing.details.late_rate" class="new-form-input">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>-->
          <hr class="my-2"/>

          <template v-if="event.entry_settings.early_bird_date">
            <div class='mb-4' v-if="event.entry_settings.has_member_pricing">
              <label class="block text-gray-700 text-sm font-bold mb-2">
                Member Early Fee
              </label>
              <input type="number" v-model.number="new_pricing.details.member_early_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
            </div>
            <div class='mb-4'>
              <label class="block text-gray-700 text-sm font-bold mb-2">
                Early Fee
              </label>
              <input type="number" v-model.number="new_pricing.details.early_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
            </div>
          </template>
          <div class='mb-4' v-if="event.entry_settings.has_member_pricing">
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Member Normal Fee
            </label>
            <input type="number" v-model.number="new_pricing.details.member_normal_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
          </div>
          <div class='mb-4'>
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Normal Fee
            </label>
            <input type="number" v-model.number="new_pricing.details.rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
          </div>
          <div class='mb-4' v-if="event.entry_settings.has_member_pricing">
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Member Late Fee
            </label>
            <input type="number" v-model.number="new_pricing.details.member_late_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
          </div>
          <div class='mb-4'>
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Late Fee
            </label>
            <input type="number" v-model.number="new_pricing.details.late_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
          </div>
          <hr class="my-2"/>
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Has Multi Entry Discounts
            </label>
            <input type="checkbox" v-model="new_pricing.details.multi_entry_pricing">
            <div v-if="new_pricing.details.multi_entry_pricing">
              <div class='mb-4'>
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  After how many entries is the multi-entry pricing applied?
                </label>
                <input type="number" v-model.number="new_pricing.details.multi_entry_number" placeholder="0" class="text-input focus:outline-none focus:shadow-outline">
                <p>If the first entry is $20 and the entries after that cost $10. You would put a 1 here.</p>
              </div>
              <div class='mb-4' v-if="event.entry_settings.early_bird_date">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  Multi Entry Early Rate
                </label>
                <input type="number" v-model.number="new_pricing.details.multi_entry_early_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
              </div>
              <div class='mb-4'>
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  Multi Entry Rate
                </label>
                <input type="number" v-model.number="new_pricing.details.multi_entry_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
              </div>
              <div class='mb-4'>
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  Multi Entry Late Rate
                </label>
                <input type="number" v-model.number="new_pricing.details.multi_entry_late_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
              </div>
            </div>
        </div>
      </form>
      <div slot="modal-footer" class="w-100">
        <button class="btn btn-green mr-3" @click="addPricingRule(new_pricing)">Save</button>
        <button class="btn btn-gray-outline" variant="primary" @click="$refs.addPricingModal.hide()">
          Cancel
        </button>
      </div>
    </b-modal>

    <b-modal id="editPricingModal" ref="editPricingModal" size="lg" :title="`Edit Pricing Rule`" no-close-on-backdrop>
      <tabs type="classic">
        <tab :selected='true' name="Basic" class="mt-4">
          <form class="mt-4">
            <div class='mb-4'>
              <label class="block text-gray-700 text-sm font-bold mb-2">
                Rule Type
              </label>
              <div class="relative">
                <select v-model="editing_pricing.type" class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                  <option :value="null" selected disabled>
                    Please select a type
                  </option>
                  <option v-for="v in pricing_types" :key="v.value" :value="v.value">
                    {{v.label}}
                  </option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
            <div class="hr"></div>

            <div v-if="editing_pricing.type == 'SHOW' || editing_pricing.type == 'MULTI'">
              <div class='mb-4'>
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  What is the name of this rule?
                </label>
                <input type="text" v-model="editing_pricing.details.name" placeholder="Rule Name" class="text-input focus:outline-none focus:shadow-outline">
              </div>
              <h5>Which shows make up this multi entry rule?</h5>
              <multiselect v-model="editing_pricing.details.show_ids" :options="showList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select multiple shows" label="name" track-by="name" :preselect-first="false" :custom-label="(option) => {return option.name ? option.name : showDecode[option].name}" :hideSelected="true"></multiselect>
              <hr class="my-2"/>

              <template v-if="event.entry_settings.early_bird_date">
                 <div class='mb-4' v-if="event.entry_settings.has_member_pricing">
                  <label class="block text-gray-700 text-sm font-bold mb-2">
                    Member Early Fee
                  </label>
                  <input type="number" v-model.number="editing_pricing.details.member_early_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
                </div>
                <div class='mb-4'>
                  <label class="block text-gray-700 text-sm font-bold mb-2">
                    Early Fee
                  </label>
                  <input type="number" v-model.number="editing_pricing.details.early_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
                </div>
              </template>
              <div class='mb-4' v-if="event.entry_settings.has_member_pricing">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  Member Normal Fee
                </label>
                <input type="number" v-model.number="editing_pricing.details.member_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
              </div>
              <div class='mb-4'>
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  Normal Fee
                </label>
                <input type="number" v-model.number="editing_pricing.details.rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
              </div>
              <div class='mb-4' v-if="event.entry_settings.has_member_pricing">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  Member Late Fee
                </label>
                <input type="number" v-model.number="editing_pricing.details.member_late_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
              </div>
              <div class='mb-4'>
                <label class="block text-gray-700 text-sm font-bold mb-2">
                  Late Fee
                </label>
                <input type="number" v-model.number="editing_pricing.details.late_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
              </div>
              <input type="checkbox" v-model="editing_pricing.details.multi_entry_pricing">
              <div v-if="editing_pricing.details.multi_entry_pricing">
                <div class='mb-4'>
                  <label class="block text-gray-700 text-sm font-bold mb-2">
                    After how many entries is the multi-entry pricing applied?
                  </label>
                  <input type="number" v-model.number="editing_pricing.details.multi_entry_number" placeholder="0" class="text-input focus:outline-none focus:shadow-outline">
                  <p>If the first entry is $20 and the entries after that cost $10. You would put a 1 here.</p>
                </div>
                <div class='mb-4' v-if="event.entry_settings.early_bird_date">
                  <label class="block text-gray-700 text-sm font-bold mb-2">
                    Multi Entry Early Rate
                  </label>
                  <input type="number" v-model.number="editing_pricing.details.multi_entry_early_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
                </div>
                <div class='mb-4'>
                  <label class="block text-gray-700 text-sm font-bold mb-2">
                    Multi Entry Rate
                  </label>
                  <input type="number" v-model.number="editing_pricing.details.multi_entry_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
                </div>
                <div class='mb-4'>
                  <label class="block text-gray-700 text-sm font-bold mb-2">
                    Multi Entry Late Rate
                  </label>
                  <input type="number" v-model.number="editing_pricing.details.multi_entry_late_rate" placeholder="$0" class="text-input focus:outline-none focus:shadow-outline">
                </div>
              </div>
            </div>
          </form>
        </tab>
        <tab v-if="editing_pricing.type === 'SHOW'" name="Advanced" class="mt-4">
          <div class="flex justify-between">
            <div class="flex-1 m-1">
              <label class="block text-gray-700 text-sm font-bold mb-2">
                Step Discount
              </label>
              <input type="number" v-model.number="editing_pricing.advanced.step_discount" class="text-input focus:outline-none focus:shadow-outline">
            </div>
            <div class="flex-1 m-1">
              <label class="block text-gray-700 text-sm font-bold mb-2">
                Number of Steps
              </label>
              <input type="number" v-model.number="editing_pricing.advanced.step_discount_number" class="text-input focus:outline-none focus:shadow-outline">
            </div>
          </div>
          <h5>Which shows make up this step rule?</h5>
          <multiselect v-model="editing_pricing.advanced.step_shows" :options="showList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select multiple shows" label="name" track-by="name" :preselect-first="false" :custom-label="(option) => {return option.name ? option.name : showDecode[option].name}" :hideSelected="true"></multiselect>

          <div class="text-sm text-gray-600">Use these settings to give discount for multiple entries in the same show. Step discount will be the amount discount starting with the second entry, use the number of steps if the price continues to decrease with addtional entries. </div>
          <div class="hr"></div>
        </tab>
      </tabs>
      <div slot="modal-footer" class="w-100">
        <button class="btn btn-green mr-3" @click="updatePricingRule(editing_pricing)">Save</button>
        <button class="btn btn-gray-outline" variant="primary" @click="$refs.editPricingModal.hide()">
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      new_pricing: {
        details: {
          show_ids: []
        },
        type: null,
        advanced: {}
      },
      editing_pricing: {
        details: {},
        advanced: {}
      },
      pricing_fields: [
        {key: 'type'},
        {key: 'rule'},
        {key: ' '}
      ],
      pricing_types: [
        {value: 'MULTI', label: 'Multi Show Pricing'}
      ]
    }
  },
  methods: {
    addPricingRule: function (rule) {
      this.$store.dispatch('createNewPricing', rule)
        .then(response => {
          this.$refs.addPricingModal.hide()
          this.notie.alert({
            type: 1,
            text: `Pricing Rule Successfully Create`
          })
          this.new_pricing = {
            details: {},
            advanced: {}
          }
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error creating pricing rule, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    removePricingRule: function (rule) {
      this.$store.dispatch('removePricing', rule)
        .then(response => {
          this.notie.alert({
            type: 2,
            text: `Pricing Rule Successfully Removed`
          })
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error deleting rule, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    editPricingRule: function (rule) {
      this.editing_pricing = rule
      this.$refs.editPricingModal.show()
    },
    updatePricingRule: function (rule) {
      this.$store.dispatch('updatePricing', rule)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Pricing rule successfully Updated`
          })
          this.$refs.editPricingModal.hide()
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error updating rule, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.$store.state.admin.adminData.event
    },
    pricing_rules () {
      return this.$store.state.admin.adminData.pricing
    },
    showDecode () {
      var obj = {}
      if (this.event) {
        this.event.shows.forEach(s => {
          obj[s.show_id] = s
        })
      }
      return obj
    },
    showList () {
      var list = []
      if (this.event) {
        this.event.shows.forEach(s => {
          // if (s.type === this.selectClassType) {
          list.push({
            value: s.show_id,
            name: s.name
          })
          // }
        })
      }
      return list
    },
    currencySymbol () {
      return this.Localized.getCurrencyInfo(this.event.location_details.country).symbol
    }
  }
}
</script>

<style>

</style>
